import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import type { CompanyLocation } from '@/types'

export function useCompanyLocations() {
  return useQuery({
    queryKey: ['engitronix-company-locations'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('engitronix_company_locations')
        .select('*')
        .eq('is_active', true)
        .order('sort_order')

      if (error) {
        console.error('Failed to load company locations:', error)
        return []
      }

      return data as CompanyLocation[]
    },
    staleTime: 60000,
  })
}

export function useAdminCompanyLocations() {
  return useQuery({
    queryKey: ['admin-engitronix-company-locations'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('engitronix_company_locations')
        .select('*')
        .order('sort_order')

      if (error) throw error
      return data as CompanyLocation[]
    },
  })
}
